import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOnboardingState } from './direct-onboarding.state';

export const selectOnboardingState = createFeatureSelector<IOnboardingState>('onboarding');

export const OnboardingSelectors = {
  // Basic selectors
  selectOnboardings: createSelector(selectOnboardingState, (state) => state.onboardings),

  selectFilters: createSelector(selectOnboardingState, (state) => state.filters),

  selectTotalCount: createSelector(selectOnboardingState, (state) => state.totalCount),

  selectCurrentPage: createSelector(selectOnboardingState, (state) => state.currentPage),

  selectIsLoading: createSelector(selectOnboardingState, (state) => state.isLoading),

  selectError: createSelector(selectOnboardingState, (state) => state.error),

  // Computed selectors
  selectHasOnboardings: createSelector(selectOnboardingState, (state) => state.onboardings.length > 0),

  selectPageSize: createSelector(selectOnboardingState, (state) => state.filters.PageSize || 10),

  selectTotalPages: createSelector(selectOnboardingState, (state) => {
    const pageSize = state.filters.PageSize || 10;
    return Math.ceil(state.totalCount / pageSize);
  }),

  selectHasNextPage: createSelector(selectOnboardingState, (state) => {
    const pageSize = state.filters.PageSize || 10;
    const totalPages = Math.ceil(state.totalCount / pageSize);
    return state.currentPage < totalPages;
  }),

  selectHasPreviousPage: createSelector(selectOnboardingState, (state) => state.currentPage > 1),

  // Filter-specific selectors
  selectActiveFiltersCount: createSelector(selectOnboardingState, (state) => {
    const filters = state.filters;
    let count = 0;
    if (filters.FirstName) count++;
    if (filters.LastName) count++;
    if (filters.CrmNumber) count++;
    if (filters.IdentityOrPassport) count++;
    return count;
  }),

  selectHasActiveFilters: createSelector(selectOnboardingState, (state) => {
    const filters = state.filters;
    return !!(filters.FirstName || filters.LastName || filters.CrmNumber || filters.IdentityOrPassport);
  }),
};
